// src/components/store/sections/gallery/GalleryV82MasonrygridCoralFlame.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV82MasonrygridCoralFlame(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={82}
      archKey="masonry_grid"
      archLabel="Dynamic Masonry"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f97316"
      {...props}
    />
  );
}
